export default __webpack_public_path__ + "static/media/leave.95692783.svg";